import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const TreeContextApi = createContext();
const useTreeContext = () => useContext(TreeContextApi);

const TreeDataContext = ({ children }) => {
  const [screensExplorerData, setScreensExplorerData] = useState(false);
  const [entityExplorerData, setEntityExplorerData] = useState(false);
  const [workflowExplorerData, setWorkflowExplorerData] = useState(false);
  const [stateMachineExplorerData, setStateMachineExplorerData] = useState(false);
  const [jobsExplorerData, setJobsExplorerData] = useState(false);
  const [blocksExplorerData, setBlocksExplorerData] = useState(false);
  const [formsExplorerData, setFormsExplorerData] = useState(false);
  const [rdbmsFormsExplorerData, setRdbmsFormsExplorerData] = useState(false);
  const [templateExplorerData, setTemplateExplorerData] = useState(false);
  const [sqlTemplateExplorerData, setSqlTemplateExplorerData] = useState(false);
  const [cronExplorerData, setCronExplorerData] = useState(false);
  const [apiExplorerData, setApiExplorerData] = useState(false);
  const [publicAccessExplorerData, setPublicAccessExplorerData] = useState(false);
  const [connectorsExplorerData, setConnectorsExplorerData] = useState(false);

  const [sidebarCollapse, setSidebarCollapse] = useState({});

  const [selectedDevice, setSelectedDevice] = useState("desktop");

  // const { applicationId } = useAxiosContext();
  const { appId } = useParams();

  useEffect(() => {
    setScreensExplorerData(false);
    setEntityExplorerData(false);
    setWorkflowExplorerData(false);
    setStateMachineExplorerData(false);
    setJobsExplorerData(false);
    setBlocksExplorerData(false);
    setFormsExplorerData(false);
    setCronExplorerData(false);
    setApiExplorerData(false);
    setPublicAccessExplorerData(false);
    setRdbmsFormsExplorerData(false);
    setSqlTemplateExplorerData(false);
    setTemplateExplorerData(false);
    setConnectorsExplorerData(false);
  }, [appId]);

  return (
    <TreeContextApi.Provider
      value={{
        screensExplorerData,
        setScreensExplorerData,
        entityExplorerData,
        setEntityExplorerData,
        workflowExplorerData,
        setWorkflowExplorerData,
        stateMachineExplorerData,
        setStateMachineExplorerData,
        jobsExplorerData,
        setJobsExplorerData,
        blocksExplorerData,
        setBlocksExplorerData,
        formsExplorerData,
        setFormsExplorerData,
        templateExplorerData,
        setTemplateExplorerData,
        cronExplorerData,
        setCronExplorerData,
        apiExplorerData,
        setApiExplorerData,
        publicAccessExplorerData,
        setPublicAccessExplorerData,
        selectedDevice,
        setSelectedDevice,
        sidebarCollapse,
        setSidebarCollapse,
        rdbmsFormsExplorerData,
        setRdbmsFormsExplorerData,
        sqlTemplateExplorerData,
        setSqlTemplateExplorerData,
        connectorsExplorerData,
        setConnectorsExplorerData
      }}
    >
      {children}
    </TreeContextApi.Provider>
  );
};

export default TreeDataContext;
export { useTreeContext };
